import { getChannelInfo, getMenuList, getWatchLoginInfo, PostInfo, getPlayAddress, getGlobalSetting, getDrainage } from '@/api/apiAll';
import QuickStorage from '@/utils/QuickStorage/index';
import gray from '@/utils/gray'

const actions = {
  async get_control({ state, commit, dispatch }, obj) {
    await Promise.all([dispatch('get_channerInfo', { id: obj.id, uin: obj.uin })]);
  },
  async get_channerInfo({ state, commit, dispatch }, obj) {
    const res = await getChannelInfo({
      id: obj.id
    });
    if (res.code === 200 && res.errorCode === 0) {
      if (res.data.status !== 1 || Number(res.data.uin) !== Number(obj.uin)) {
        commit('set_status', 404);
        return false;
      }
      res.data.watchNum = 0;
      commit('set_channelInfo', res.data);
      commit('set_wechatInfo', res.data.channelWeChatInfo || {});
      commit('set_status', 200);
      await Promise.all([dispatch('get_menuList'), dispatch('get_drainage')]);
    } else if (res.code === 200 && res.errorCode === 3) {
      commit('set_status', 408);
    } else {
      commit('set_status', 404);
    }
  },
  async get_drainage({ state, commit }) {
    const { drainage_ID, drainage_status } = state.channelInfo
    if (!drainage_ID) return
    const drainage = await getDrainage({
      drainage_id: drainage_ID,
    })
    if (drainage.code === 200 && drainage.errorCode === 0) {
      commit('set_drainage', {
        ...drainage.data,
        drainage_ID,
        drainage_status,
      })
    }
  },
  async get_menuList({ state, commit }) {
    const res = await getMenuList({
      id: state.channelInfo.id,
      uin: state.channelInfo.uin
    });
    if (res.code === 200 && res.errorCode === 0) {
      let list = [];
      if (res.data.length) {
        list = res.data;
      } else {
        list = [
          {
            menuName: '聊天互动',
            menuType: 'chat'
          }
        ];
      }
      commit('set_menuList', list);
    }
  },
  async get_userInfo({ state, commit, dispatch }) {
    const res = await getWatchLoginInfo({
      id: state.channelInfo.id,
      uin: state.channelInfo.uin
    });
    if (res.code === 200 && res.errorCode === 0) {
      commit('set_userInfo', res.data.watchUserInfo);
      const channelInfo = JSON.parse(JSON.stringify(state.channelInfo));
      channelInfo.watchNum = res.data.watchNum;
      commit('set_channelInfo', channelInfo);
      dispatch('PostInfo');
    }
  },
  async PostInfo({ state }) {
    const res = await PostInfo({
      channelId: state.channelInfo.id,
      uin: state.channelInfo.uin,
      userId: state.userInfo.id || 0,
      type: 2, // radio
      deviceid: QuickStorage.localGet('DEVICE_ID')
    });
    if (res.code === 200 && res.errorCode === 0) {
      // console.log(res)
    }
  },
  async get_playAddress({ state, commit }) {
    const res = await getPlayAddress({
      id: state.channelInfo.id,
      uin: state.channelInfo.uin,
      clientId: state.uuid
    });
    if (res.code === 200 && res.errorCode === 0) {
      commit('set_playAddress', res.data.hlsUrl || '');
    }
    // commit('set_playAddress', 'https://31513.hlsplay.aodianyun.com/tv_radio_31513/radio_channel_759.m3u8?auth_key=1695433203-0-0-2989a3155a626788d3caf9941b9cc022&extra_key=19ovgcBPY8AQ5z0ef5F3gfsLCDt_BeMzTP38X0PZC94tv6S6heN2OJnMChwXpa1Bq3LyBhLFbFUvbsY1l2X3_sXajowP0YaFH2BUnK1Q99aB-PEaMGyF559awpQBhtM2w39iSy4o443H0qfOnYD0dRCFfZTfnRkpLvKHEvUQTHM');
  },
  async get_globalSetting({ state, commit }) {
    const res = await getGlobalSetting({
      uin: state.channelInfo.uin,
    });
    if (res.code === 200 && res.errorCode === 0) {
      commit('set_globalSetting', res.data);
      if (res.data.blackWhiteMode === 1) {
        gray()
      }
    }
  },

};
export default actions;
